import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            热播榜单
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            实时更新的播放热度排行榜，看看本周最火的是哪部
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="rounded-2xl overflow-hidden bg-background-100 border border-background-200/70">
            {rankingItems.map((item, index) => (
              <div
                key={item.id}
                className={`flex items-center gap-4 p-4 md:p-5 transition-colors duration-200 cursor-pointer hover:bg-background-200/50 ${
                  index < rankingItems.length - 1 ? 'border-b border-background-200/60' : ''
                }`}
              >
                <div className={`w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg shrink-0 ${
                  item.rank === 1
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-secondary-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-primary-400 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  <span className="text-sm font-bold font-heading">{item.rank}</span>
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-2 mt-0.5">
                    <span className="text-xs text-foreground-500">{item.type}</span>
                    <span className="text-xs text-foreground-400">{item.hot}</span>
                  </div>
                </div>

                <div className="flex items-center gap-2 shrink-0">
                  <div className="w-5 h-5 flex items-center justify-center">
                    {item.change === 'up' ? (
                      <i className="ri-arrow-up-line text-sm text-primary-500"></i>
                    ) : item.change === 'down' ? (
                      <i className="ri-arrow-down-line text-sm text-foreground-400"></i>
                    ) : (
                      <i className="ri-subtract-line text-sm text-foreground-400"></i>
                    )}
                  </div>
                  <a
                    href="#media"
                    className="px-3 py-1.5 text-xs font-medium rounded-full bg-primary-100 text-primary-600 whitespace-nowrap cursor-pointer hover:bg-primary-200 transition-colors"
                  >
                    立即观看
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}